import {
  Element as SlateElement,
  Text as SlateText
} from "slate";
const RootBlockType = {
  Default: "default",
  Paragraph: "paragraph",
  Heading1: "heading-one",
  Heading2: "heading-two",
  Heading3: "heading-three",
  Heading4: "heading-four",
  Heading5: "heading-five",
  Heading6: "heading-six",
  BlockQuote: "blockquote",
  UnorderedList: "unordered-list",
  OrderedList: "ordered-list"
};
const BlockType = {
  ...RootBlockType,
  ListItem: "list-item",
  ListItemChild: "list-item-child"
};
const Text = SlateText;
function isText(node) {
  if (typeof node === "object" && "text" in node)
    return true;
  return false;
}
const BlockTextAlignment = {
  Left: "left",
  Center: "center",
  Right: "right",
  Justify: "justify"
};
function isDefaultElement(node) {
  return Element.isElementType(node, BlockType.Default);
}
function isList(node) {
  return Element.isElementType(node, BlockType.OrderedList) || Element.isElementType(node, BlockType.UnorderedList);
}
function isListItem(node) {
  return Element.isElementType(node, BlockType.ListItem);
}
function isListItemChild(node) {
  return Element.isElementType(node, BlockType.ListItemChild);
}
function isConvertibleToListTextNode(node) {
  return !isList(node) && !isListItem(node) && !isListItemChild(node);
}
function isHeading(node) {
  return Element.isElementType(node, BlockType.Heading1) || Element.isElementType(node, BlockType.Heading2) || Element.isElementType(node, BlockType.Heading3) || Element.isElementType(node, BlockType.Heading3) || Element.isElementType(node, BlockType.Heading4) || Element.isElementType(node, BlockType.Heading5) || Element.isElementType(node, BlockType.Heading6);
}
function isRootBlock(node) {
  return Element.isElement(node) && (Element.isElementType(node, BlockType.Paragraph) || Element.isElementType(node, BlockType.BlockQuote) || isHeading(node) || isList(node) || isDefaultElement(node));
}
function isBlock(node) {
  return Element.isElement(node) && (isRootBlock(node) || Element.isElementType(node, BlockType.ListItem) || Element.isElementType(node, BlockType.ListItemChild));
}
const InlineType = {
  Code: "code",
  SuperScript: "superscript",
  SubScript: "subscript",
  Link: "link"
};
function isLink(node) {
  return Element.isElement(node) && Element.isElementType(node, InlineType.Link);
}
function isInline(node) {
  return Element.isElement(node) && (Element.isElementType(node, InlineType.Code) || Element.isElementType(node, InlineType.Link) || Element.isElementType(node, InlineType.SubScript) || Element.isElementType(node, InlineType.SuperScript));
}
const Element = SlateElement;
export {
  BlockTextAlignment,
  BlockType,
  Element,
  InlineType,
  RootBlockType,
  Text,
  isBlock,
  isConvertibleToListTextNode,
  isDefaultElement,
  isHeading,
  isInline,
  isLink,
  isList,
  isListItem,
  isListItemChild,
  isRootBlock,
  isText
};
//# sourceMappingURL=slate.js.map